module.exports = __webpack_public_path__ + "static/media/add-icon-black.af273f64.svg";